import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {},
  error: undefined,
};

const get = async (store, meta = {}) => {
  store.setState((state) => {
    state.admin.config.list.busy = true;
  });

  try {
    const params = {
      ...meta,
    };

    const response = await Http.get('api/config', { params });

    store.setState((state) => {
      state.admin.config.list.busy = false;
      state.admin.config.list.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.config.list.error = error.data || error;
      state.admin.config.list.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.admin.config.list.error = undefined;
};

const actions = {
  get,
  resetError,
};

const ConfigListStore = {
  state: () => initialState,
  actions,
};

export default ConfigListStore;
